<template>
    <WhiteTable :labels="[$translate.text('general.name'), $translate.text('general.location.type'),'']">
        <template slot="table-data">
            <tr v-for="(item, index) in items" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ item.location }}</td>
                <td>{{ item.type }}</td>
                <td class="align-right">
                    <i class="fal fa-external-link-square" @click="goToRoute(item)" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                </td>

            </tr>
            <tr v-if="!items.length">
                <td colspan="4">{{ t('general.no_attentions') }}</td>
            </tr>
        </template>
    </WhiteTable>
</template>
<script>
import WhiteTable from '@/components/Table/WhiteTable';

export default {
    name: 'Attention',

    components: {
        WhiteTable,
    },


    props: {
        attentionItems: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        goToRoute(item) {
            if (item.location === 'Feed') {
                this.$router.push({ name: 'Clients Feeds Combine', params: { id: item.id } });
            } else if (item.location === 'Connection') {
                if (item.type === 'Categories') {
                    this.$router.push({ name: 'Clients Connections Categories', params: { id: item.id } });
                } else if (item.type === 'Brands') {
                    this.$router.push({ name: 'Clients Connections Brands', params: { id: item.id } });
                } else if (item.type === 'Attributes') {
                    this.$router.push({ name: 'Clients Connections Attributes', params: { id: item.id } });
                } else if (item.type === 'Price') {
                    this.$router.push({ name: 'Clients Connections Pricing', params: { id: item.id } });
                }
            }
        },
    },

    computed: {
        items() {
            const values = [];
            this.attentionItems.forEach(attentions => {
                if (attentions.feedcombine) {
                    attentions.feedcombine.forEach(attention => {
                        const array = {
                            type: 'Combine',
                            location: 'Feed',
                            name: attention.name,
                            id: attention.id,
                        };
                        values.push(array);
                    });
                }

                if (attentions.connection_price) {
                    attentions.connection_price.forEach(attention => {
                        const array = {
                            type: 'Price',
                            location: 'Connection',
                            name: attention.name,
                            id: attention.id,
                        };
                        values.push(array);
                    });
                }

                if (attentions.connection_attributes) {
                    attentions.connection_attributes.forEach(attention => {
                        const array = {
                            type: 'Attributes',
                            location: 'Connection',
                            name: attention.name,
                            id: attention.id,
                        };
                        values.push(array);
                    });
                }

                if (attentions.connection_brands) {
                    attentions.connection_brands.forEach(attention => {
                        const array = {
                            type: 'Brands',
                            location: 'Connection',
                            name: attention.name,
                            id: attention.id,
                        };
                        values.push(array);
                    });
                }

                if (attentions.connection_categories) {
                    attentions.connection_categories.forEach(attention => {
                        const array = {
                            type: 'Categories',
                            location: 'Connection',
                            name: attention.name,
                            id: attention.id,
                        };
                        values.push(array);
                    });
                }
            });
            return values;
        },
    },
};
</script>
